"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Radio component abstracting Material's Radio system
 */
class Radio extends _react.default.PureComponent {
  /**
   * Value changed.
   *
   * @param {Event} e
   * @return {void}
   */
  handleChange = e => {
    this.props.onChange(this.options[parseInt(e.target.value)]?.value, this.props.name);
  };
  /**
   * Render.
   * 
   * @return {ReactNode}
   */

  render() {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_core.FormControl, {
      className: this.props.className,
      component: "fieldset",
      disabled: this.props.disabled,
      error: this.props.error,
      margin: "none",
      required: this.props.required,
      children: [this.props.label && !this.props.hideLabel && /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.FormLabel, {
        color: this.props.color,
        component: "legend",
        children: this.props.label
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.RadioGroup, {
        name: this.props.name,
        onChange: this.handleChange,
        required: this.props.required,
        row: this.props.row,
        value: this.options.map(v => v.value).indexOf(this.props.value),
        children: this.options.map((option, key) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.FormControlLabel, {
          control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Radio, {
            color: this.props.color,
            disabled: option.disabled,
            inputProps: this.props.inputProps,
            required: this.props.required,
            size: this.props.size
          }),
          label: option.label,
          value: key
        }, key))
      })]
    });
  }
  /**
   * Get our options.
   *
   * @return {Array<Object>} Option objects
   */


  get options() {
    return this.props.options?.filter(o => !o.hidden);
  }

  static propTypes = {
    className: _propTypes.default.string,
    color: _propTypes.default.oneOf(["primary", "secondary"]),
    disabled: _propTypes.default.bool,
    error: _propTypes.default.bool,
    hideLabel: _propTypes.default.bool,
    inputProps: _propTypes.default.object,
    label: _propTypes.default.string,
    name: _propTypes.default.string,
    onChange: _propTypes.default.func,
    options: _propTypes.default.arrayOf(_propTypes.default.object),
    required: _propTypes.default.bool,
    row: _propTypes.default.bool,
    size: _propTypes.default.oneOf(["small", "medium"]),
    value: _propTypes.default.any
  };
  static defaultProps = {
    color: "primary",
    disabled: false,
    error: false,
    hideLabel: false,
    required: false,
    row: false,
    size: "small"
  };
}

var _default = Radio;
exports.default = _default;